import React from 'react'
import { Link } from 'react-router-dom'

function IndustriesOpenDoor() {
    return (
        <section className="industries-open td-section rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-lg-11">
                        <div className="industries-open__panel">
                            <h2 className="industries-open__title">Your Industry Isn&apos;t on This List?</h2>
                            <p className="industries-open__lead">
                                Good. That means you&apos;re about to have a conversation nobody in your space has had yet.
                            </p>
                            <div className="industries-open__body">
                                <p>
                                    Every industry produces experts who can&apos;t find the time to write. Every business
                                    holds data that someone wants to steal. Every organization has operational problems
                                    that generic vendors keep failing to solve.
                                </p>
                                <p>
                                    TechDigit Solutions doesn&apos;t limit itself to a list. We limit ourselves to doing
                                    exceptional work—and exceptional work is needed everywhere. If you&apos;re serious about
                                    what you&apos;re building, reach out. The first conversation is free, it&apos;s genuinely
                                    useful and there&apos;s no obligation on either side.
                                </p>
                            </div>
                            <h3 className="industries-open__sub">
                                We&apos;ve worked with healthcare providers, technology companies, financial firms,
                                independent authors, coaches, consultants, and businesses that don&apos;t fit neatly into
                                any category. The one thing they all had in common was that they needed something done
                                properly—not just done.
                            </h3>
                            <div className="industries-open__cta-row">
                                <Link to="/contactus" className="rts-btn btn-primary deactive">
                                    Schedule Your Free Consultation
                                </Link>
                                <div className="industries-open__contact">
                                    <a href="mailto:info@techdigitsolutions.com">info@techdigitsolutions.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IndustriesOpenDoor
